import { __assign } from "tslib";
// DS: CR28M
import React, { useState, useEffect, useRef, useCallback, useContext, } from 'react';
import classnames from 'classnames';
import { Url } from '@wix/da-url';
import LoadingIndicator from '../../../LoadingIndicator';
import Button from '../../../Button';
import Flex from '../../../Flex';
import LiveSettingsDropdown from '../../_partials/LiveSettingsDropdown';
import { ThemeOverride, ThemeOptions, } from '@wix/da-react-context/pkg/ThemeContext';
import { IconSize } from '../../../Icons/IconWrap';
import CloseBig from '../../../Icons/CloseBig';
import NotificationIcon from '../../../Icons/24x24/Notification';
import { useTranslation } from 'react-i18next';
import { useBodyScrollLock } from '../../../utils/hooks/useBodyScollLock';
import ReloadButton from '../../_partials/ReloadButton';
import { BiEventType } from '../../../biLogger/constants';
import { ScreenSizeContext } from '../../../Measured';
import SiteHeaderIconButton from '../_partials/SiteHeaderIconButton';
import s from './NotificationsDropdownMobile.scss';
function calculateHeight(height) {
    var styles = getComputedStyle(document.documentElement);
    var safeBottomMargin = parseInt(styles.getPropertyValue('--safe-bottom-margin'));
    return (height -
        parseInt(s['footer-see-all-height']) -
        parseInt(s['title-container-height']) -
        safeBottomMargin);
}
var NotificationsDropdownMobile = function (_a) {
    var feedbackCount = _a.feedbackCount, isOpen = _a.isOpen, onClick = _a.onClick, biData = _a.biData, onClose = _a.onClose, hasBeenOpened = _a.hasBeenOpened, newFeedbackCount = _a.newFeedbackCount, resetNewFeedback = _a.resetNewFeedback, className = _a.className;
    var t = useTranslation().t;
    var iframeRef = useRef(null);
    var _b = useState(true), isLoading = _b[0], setLoading = _b[1];
    var _c = useState(false), isLiveDropdownOpen = _c[0], setLiveDropdownOpen = _c[1];
    var _d = useBodyScrollLock(), onLock = _d.onLock, onUnlock = _d.onUnlock, setScrollableRef = _d.setScrollableRef;
    var screenHeight = useContext(ScreenSizeContext).height;
    var setIframeRef = function (node) {
        iframeRef.current = node;
        setScrollableRef(node);
    };
    useEffect(function () {
        if (isOpen) {
            // fix for iOS use of 100vh
            if (typeof window !== 'undefined' && iframeRef.current) {
                iframeRef.current.style.height = calculateHeight(screenHeight) + "px";
            }
            onLock();
        }
        else {
            onUnlock();
        }
    }, [isOpen, onLock, onUnlock, screenHeight]);
    var reloadIframe = useCallback(function () {
        var iframe = iframeRef.current;
        if (iframe && iframe.contentWindow) {
            setLoading(true);
            resetNewFeedback();
            iframe.contentWindow.location.reload();
        }
    }, [iframeRef, setLoading, resetNewFeedback]);
    return (React.createElement("div", { className: className },
        React.createElement(SiteHeaderIconButton, { icon: NotificationIcon, biData: biData, onClick: onClick, ariaLabel: t('siteHeader.a11y.notifications'), count: feedbackCount }),
        React.createElement(ThemeOverride, { theme: ThemeOptions.LIGHT, className: classnames(s['container'], isOpen && s['active'], isLiveDropdownOpen && s['live-settings-open']) },
            React.createElement(Flex, { justifyContent: "space-between", alignItems: "center", className: s['title-container'] },
                React.createElement("span", { className: s['title'] }, isLiveDropdownOpen
                    ? t('siteHeader.notificationsMenu.liveTitleMobile')
                    : t('siteHeader.notificationsMenu.titleMobile')),
                React.createElement(LiveSettingsDropdown, { className: s['live-dropdown'], onOpen: function () { return setLiveDropdownOpen(true); }, onClose: function () { return setLiveDropdownOpen(false); }, isOpen: isLiveDropdownOpen }),
                React.createElement("div", { onClick: function (e) {
                        e.stopPropagation();
                        // If live settings dropdown is open, apply close button to that panel
                        if (isLiveDropdownOpen) {
                            setLiveDropdownOpen(false);
                        }
                        else {
                            onClose && onClose();
                        }
                    } },
                    React.createElement(CloseBig, { size: IconSize.COMPACT, disableDefaultColors: true, className: s['close'] }))),
            newFeedbackCount > 0 && (React.createElement(ReloadButton, { onClick: reloadIframe, className: s['reload-button'], count: newFeedbackCount })),
            React.createElement("div", { className: s['separator'] }),
            React.createElement(Flex, { direction: "column", className: s['notifications-frame-wrapper'] },
                React.createElement("iframe", __assign({ title: "Eclipse notifications", id: "eclipse-notifications-iframe", className: s['notifications-frame'] }, ((isOpen || hasBeenOpened) && {
                    src: Url.notificationsHeaderLink(),
                }), { ref: setIframeRef, frameBorder: "0", scrolling: isLoading ? 'no' : 'yes', onLoad: function () {
                        // note: this will fire if src is not yet set (or even when the src attribute is missing entirely)
                        // so we wait until it's loading our src document to stop showing the loading indicator
                        (isOpen || hasBeenOpened) && setLoading(false);
                        if ((isOpen || hasBeenOpened) &&
                            typeof document !== 'undefined' &&
                            typeof window !== 'undefined' &&
                            window.location.host.indexOf('deviantart.com') !== -1) {
                            document.domain = 'deviantart.com';
                        }
                    } }))),
            isLoading && (React.createElement(LoadingIndicator, { view: "spinner", className: s['loader'] })),
            React.createElement(Button, { href: Url.feedbackLink(), className: s['footer-see-all'], target: "_top", view: "b81", biData: {
                    evid: BiEventType.TOP_NAV_MENU_CLICK,
                    menu_name: 'notifications',
                    menu_item: 'see_all',
                } }, t('siteHeader.notificationsMenu.seeAll')))));
};
export default NotificationsDropdownMobile;
//# sourceMappingURL=NotificationsDropdownMobile.js.map